<template>
  <v-data-table
    disable-pagination
    style="width: 100%"
    :headers="headers"
    :items="fixedCosts"
    hide-default-footer
  >
    <template v-slot:item="props">
      <tr>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.pickup_location.name }}</td>
        <td>{{ props.item.destination_location.name }}</td>
        <td>{{ props.item.enabled ? "Yes" : "No" }}</td>
        <td><v-btn x-small @click="copy(props.item)">Reverse</v-btn><v-btn x-small @click="goToFixedCost(props.item.id)">View</v-btn></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "fixed_cost_list",
  props: {
    fixedCosts: Array
  },
  data: function() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Pickup", value: "calories", sortable: false },
        { text: "Destination", value: "fat", sortable: false },
        { text: "Enabled", value: "carbs", sortable: false },
        { text: "Actions", value: "", sortable: false }
      ]
    };
  },
  methods: {
    copy(item) {
      this.$router.push(`/settings/pricing/fixed_cost/create?copyFrom=${item.id}`);
    },
    goToFixedCost: function(id) {
      this.$router.push(`/settings/pricing/fixed_cost/${id}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
